export default "__VITE_ASSET__Bdf9zH66__"